import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";

export async function getNextCodigo(): Promise<number> {
    const response = await api.get("articulos/next-codigo");
    return response.data;
}

export function useGetNextCodigoQuery() {
    return useQuery({
        queryFn: getNextCodigo,
        queryKey: ["articulos", "next-codigo"],
    });
}
